import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiVercel,
} from "react-icons/si";
import { FaGithub } from "react-icons/fa";
import { TbBrandOpenai } from "react-icons/tb";
import { DiGit } from "react-icons/di";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaGithub/>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <TbBrandOpenai />
      </Col>
    </Row>
  );
}

export default Toolstack;
